import { template } from "@ember/template-compiler";
import { assert } from '@ember/debug';
import { on } from '@ember/modifier';
import type { TOC } from '@ember/component/template-only';
const reset = (event1: Event)=>{
    assert('[BUG]: reset called without an event.target', event1.target instanceof HTMLElement);
    let form1 = event1.target.closest('form');
    assert('Form is missing. Cannot use <Reset> without being contained within a <form>', form1 instanceof HTMLFormElement);
    form1.reset();
};
export const Submit: TOC<{
    Element: HTMLButtonElement;
    Blocks: {
        default: [];
    };
}> = template(`
  <button type="submit" ...attributes>Submit</button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export const Reset: TOC<{
    Element: HTMLButtonElement;
    Blocks: {
        default: [];
    };
}> = template(`
  <button type="button" {{on "click" reset}} ...attributes>{{yield}}</button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
